import { Observable } from "rxjs";
import { ICodeNameDto } from "../../../interface/dto/code-name.dto";
import { get } from "../../../service/api";
import { ITokenPair } from "../../auth/interface/dto/token-pair";

export const getSICCodes = (
    tokens: ITokenPair,
): Observable<Array<ICodeNameDto>> =>
    get<Array<ICodeNameDto>>("/common/sic-codes", undefined, tokens);
